import {
    Boxes,
    ChevronDown,
    Settings,
    SquareTerminal,
} from "lucide-react";

export const sidebarMenus = {
    navMain: [
        {
            title: "Dashboard",
            url: "/company/dashboard",
            icon: SquareTerminal,
            isActive: true,
        },
    ],
    navViews: {
        label: "Views",
        icon: ChevronDown,
    },
    navBelowViews: [
        {
            title: "Inventory",
            url: "/company/inventory",
            icon: Boxes,
        },
    ],
    navSecondary: [
        {
            title: "Settings",
            url: "/settings/general",
            icon: Settings,
        },
    ],
};